import React, { useState, useRef } from 'react';
import { Modal, Button, Form, Alert, ProgressBar } from 'react-bootstrap';
import { FaUpload, FaDownload } from 'react-icons/fa';

const EmployeeBulkOperations = ({ show, onHide, onRefresh }) => {
    const [loading, setLoading] = useState(false);
    const [result, setResult] = useState(null);
    const fileInputRef = useRef(null);

    const handleImportEmployees = async (event) => {
        const file = event.target.files[0];
        if (!file) return;

        setLoading(true);
        const formData = new FormData();
        formData.append('file', file);

        try {
            const response = await fetch('/api/bulkoperations/import-employees', {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                },
                body: formData
            });

            const data = await response.json();
            setResult(data);
            if (data.successCount > 0 && onRefresh) onRefresh();
        } catch (error) {
            setResult({ successCount: 0, errorCount: 1, errors: [error.message] });
        } finally {
            setLoading(false);
        }
    };

    const handleExportEmployees = async () => {
        try {
            const response = await fetch('/api/bulkoperations/export-employees', {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            });

            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = 'employees.csv';
            a.click();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            setResult({ successCount: 0, errorCount: 1, errors: [error.message] });
        }
    };

    const downloadTemplate = () => {
        const csv = "Id,Name,USL,Mobile,Department,ExternalEmployeeId\n" +
                   "EMP001,John Doe,USL001,9876543210,IT,EXT001\n" +
                   "EMP002,Jane Smith,USL002,9876543211,HR,EXT002";
        
        const blob = new Blob([csv], { type: 'text/csv' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'employee_import_template.csv';
        a.click();
        window.URL.revokeObjectURL(url);
    };

    return (
        <Modal show={show} onHide={onHide} size="lg">
            <Modal.Header closeButton>
                <Modal.Title><FaUpload className="me-2" />Employee Bulk Operations</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {result && (
                    <Alert variant={result.errorCount > 0 ? 'warning' : 'success'} className="mb-3">
                        <strong>Operation Complete:</strong> {result.successCount} successful, {result.errorCount} errors
                        {result.errors.length > 0 && (
                            <ul className="mt-2 mb-0">
                                {result.errors.slice(0, 5).map((error, index) => (
                                    <li key={index}>{error}</li>
                                ))}
                                {result.errors.length > 5 && <li>... and {result.errors.length - 5} more errors</li>}
                            </ul>
                        )}
                    </Alert>
                )}

                {loading && <ProgressBar animated now={100} className="mb-3" />}

                <h5>Import Employees</h5>
                <div className="mb-3">
                    <Button variant="outline-secondary" size="sm" onClick={downloadTemplate}>
                        Download Template
                    </Button>
                </div>
                <Form.Group className="mb-4">
                    <Form.Label>Select CSV File</Form.Label>
                    <Form.Control 
                        type="file" 
                        accept=".csv"
                        ref={fileInputRef}
                        onChange={handleImportEmployees}
                        disabled={loading}
                    />
                    <Form.Text className="text-muted">
                        CSV format: Id, Name, USL, Mobile, Department, ExternalEmployeeId
                    </Form.Text>
                </Form.Group>

                <hr />

                <h5>Export Employees</h5>
                <Button variant="success" onClick={handleExportEmployees}>
                    <FaDownload className="me-1" /> Export All Employees
                </Button>
            </Modal.Body>
        </Modal>
    );
};

export default EmployeeBulkOperations;